import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import DeviceInformation from '../../components/DeviceInformation';
import InventoryManagement from '../../components/InventoryManagement';
import ShadowPopup from '../../components/ShadowPopup';
import Notification from '../../components/Notification';
import useApi from '../../api/useApi';

function Table() {
  const [openCreate, setOpenCreate] = useState(false);
  const [openCsv, setOpenCsv] = useState(false);
  const [selectedDevice, selectDevice] = useState({ id: '', name: '' });
  const [deleteDevices, selectDeleteDevices] = useState([]);
  const [Gateway, setGateway] = useState('');
  const [toggleGateway, setToggleGateway] = useState(false);
  const [devices, setDevices] = useState([]);
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({ q: '', device_type: '', assigned: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const [orgData, setOrgData] = useState([]);
  const [assignedOrgs, setAssignedOrgs] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const [pageCount, setpageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const [deviceTypes, setDeviceTypes] = useState([]);

  const [{ isLoading, isError, data }, getData] = useApi();
  const [state, deleteDevice] = useApi();
  const [organizationData, getOrganizationData] = useApi();
  const [deviceTypeRes, getDeviceTypes] = useApi();

  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    getData(`/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
    getOrganizationData(`/organizations`, 'GET');
    getDeviceTypes('/deviceTypes', 'GET');
  }, []);

  useEffect(() => {
    if (!organizationData.isLoading && !organizationData.isError && organizationData.data) {
      setAssignedOrgs(organizationData.data.organization);
    }
  }, [organizationData.isLoading, organizationData.isError, organizationData.data]);

  useEffect(() => {
    if (!deviceTypeRes.isLoading && !deviceTypeRes.isError && deviceTypeRes.data) {
      setDeviceTypes(deviceTypeRes?.data?.deviceTypes || []);
    }
  }, [deviceTypeRes.isLoading, deviceTypeRes.isError, deviceTypeRes.data]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      let y = data.devices;

      // if (formData.project_name) {
      //   z = z.filter(
      //     (x) =>
      //       x?.device?.project?.projectName === formData.project_name ||
      //       x?.project?.projectName === formData.project_name
      //   );
      // }
      if (formData.device_type) {
        y = y.filter((x) => x?.device?.deviceType === formData.device_type || x?.deviceType === formData.device_type);
      }

      if (formData.status) {
        y = y.filter(
          (x) => x?.device?.isActive.toString() === formData.status || x?.isActive.toString() === formData.status,
        );
      }

      if (y.length > 0) {
        setDevices(y);
        setFilteredData(y);
      } else setDevices([]);

      if (page === 1) {
        let total = Math.ceil((data.count || data.devices.length) / itemsPerPage);
        if (isNaN(total)) total = 1;
        setpageCount(total);
      }

      // setDevices(data.devices);
      // setFilteredData(data.devices);
      // const z = data.devices.map((item) => {
      //   return {
      //     organizationName: item.Organization?.organizationName,
      //     id: item.Organization?.id,
      //   };
      // });
      // const key = 'id';
      // const arrayUniqueByKey = [...new Map(z.map((item) => [item[key], item])).values()];
      // setAssignedOrgs(arrayUniqueByKey);
    }
    if (isError) {
      setType('error');
      setMessage('Unable to fetch Device');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!searchFlag) {
      if (!formData.device_type && !formData.status && !formData.assigned) {
        getData(`/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
      } else {
        getData(
          `/devices?limit=${itemsPerPage}&deviceType=${formData.device_type}&isActive=${formData.status}&org=${formData.assigned}&page=${page}`,
          'GET',
        );
      }
    }
  }, [page]);

  useEffect(() => {
    setSearchFlag(false);
    if (page === 1) {
      getData(
        `/devices?limit=${itemsPerPage}&deviceType=${formData.device_type}&isActive=${formData.status}&org=${formData.assigned}&page=${page}`,
        'GET',
      );
    } else setPage(1);
  }, [formData.assigned, formData.device_type, formData.status]);

  // useEffect(() => {
  //   if (devices.length <= 0) {
  //     return;
  //   }

  //   if (formData.q === '' && formData.type === '' && formData.assigned === '' && formData.isActive === '') {
  //     setFilteredData(devices);
  //   }

  //   let z = devices;

  //   if (formData.type) {
  //     z = z.filter((item) => item.deviceType === formData.type);
  //   }

  //   if (formData.assigned) {
  //     z = z.filter((item) => item.Organization?.organizationName === formData.assigned);
  //   }
  //   if (formData.isActive) {
  //     z = z.filter((item) => item.isActive);
  //   }
  //   if (formData.isActive === false) {
  //     z = z.filter((item) => !item.isActive);
  //   }

  //   if (formData.q) {
  //     z = z.filter((x) => {
  //       const normalizedQuery = formData.q.toLowerCase();
  //       return (
  //         x?.id?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
  //         x?.deviceType.toLowerCase().indexOf(normalizedQuery) >= 0
  //       );
  //     });
  //   }

  //   if (z.length > 0) setFilteredData(z);
  //   else setFilteredData([]);
  // }, [formData]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const toggleShadow = () => {
    setToggleGateway((prev) => !prev);
  };

  const toggleOpenCsv = () => {
    setOpenCsv((prev) => !prev);
  };

  const handleDelete = () => {
    deleteDevice(`/device/${selectedDevice.id}`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      selectDeleteDevices([]);
      getData(`/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
      setType('success');
      setMessage('Device Deleted Successfully');
      setNotification(!notification);
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to Delete Device');
      setNotification(!notification);
    }
  }, [state]);

  const refreshList = () => {
    getData(`/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };
  const handleInputBoolean = useCallback((e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value === 'true' ? true : e.target.value === 'false' ? false : '',
    }),
  );
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const hideNotification = (msg) => {
    setNotification(false);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    return moment(_date).fromNow();
  };

  const searchData = () => {
    setSearchFlag(true);
    // getData(`/search?type=project&searchItem=${formData.q}`, 'GET');
    getData(`/search?type=device&searchItem=${formData.q}&limit=${itemsPerPage}&page=1`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      setSearchFlag(false);
      setPage(1);
      getData(
        `/devices?limit=${itemsPerPage}&deviceType=${formData.device_type}&isActive=${formData.status}&org=${formData.assigned}&page=1`,
        'GET',
      );
    }
  }, [formData.q]);

  return (
    <>
      {notification && <Notification type={type} message={message} hideNotification={hideNotification} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-full sm:w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block p-4 font-bold border-b text-textBlue1">Delete Device</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm my-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete Device {selectedDevice.id}?
            </span>
            <div className="mb-6 font-bold float-right mr-8 w-2/3">
              <div className="w-1/3" />
              <div className=" w-full sm:w-2/3 flex">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center h-7"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <DeviceInformation
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedDevice={selectedDevice.id}
          refreshList={() => refreshList()}
          deviceTypes={deviceTypes}
        />
      )}
      {openCsv && (
        <InventoryManagement
          handleClose={toggleOpenCsv}
          action={action}
          notification={createNotification}
          refreshList={() => refreshList()}
        />
      )}

      {toggleGateway && <ShadowPopup handleClose={toggleShadow} gatewayId={Gateway} />}

      <div
        className="mt-10 md:mt-0 lg:m-8 static md:fixed bg-white w-full sm:w-10/12 overflow-scroll lg:overflow-hidden devices nav_devices"
        style={{
          filter: openCreate && 'blur(2px)',
        }}
      >
        <div className="h-16 sm:h-40">
          <div className="pt-4 md:pt-8 lg:flex block sm:block sm:justify-between text-left sm:text-center lg:text-left w-tableWidth m-auto ">
            <span className="text-textBlue1 font-bold text-lg">Devices</span>

            <div className="flex mt-0 float-right">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-max border px-3 py-1 rounded-md text-xs mx-0 sm:mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCsv();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                BULK UPLOAD(CSV)
              </button>
              <button
                className="mt-1 lg:mt-0 w-max border px-3 py-1 rounded-md text-xs mx-0 sm:mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>

              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2 ">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 button_search3 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl">
          <div className="bg-white w-tableWidth m-auto mb-3" style={{ minWidth: '900px' }}>
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 items-center flex w-full relative bg-primary text-white text-left text-xs font-bold">
                {/* <div className="w-1/3 ">DEVICE ID</div> */}
                <div className="w-1/4 py-1">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-3 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.device_type}
                      name="device_type"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-3 pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option className="dummy" value="">
                        DEVICE
                      </option>
                      {deviceTypes.map((z) => (
                        <option value={z.slug} key={z.slug}>
                          {z.displayName}
                        </option>
                      ))}
                      {/* <option value="CATM1_TAG">Cellular Tag</option>
                      <option value="BLE_GW">BLE Gateway</option>
                      <option value="NFC_TAG">NFC TAG</option> */}
                    </select>
                  </div>
                </div>
                <div className="w-1/4 py-1">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-3 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.assigned}
                      name="assigned"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">ASSIGNED TO</option>
                      {assignedOrgs.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.organizationName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* <div className="w-1/5">STATUS</div> */}
                <div className="w-1/4 py-1">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-3 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputBoolean}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div className="w-1/5">LAST MODIFIED</div>
                <div className="w-1/5">ACTION</div>
              </div>
            </div>

            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
                {filteredData.map((item, idx) => (
                  <div
                    className="my-1 px-8 flex
                  relative hover:border-indigo-200 focus-within:border-indigo-200 text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                    style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    onClick={() => {
                      if (item.deviceType === 'BLE_GW') {
                        setGateway(item?.id);
                        toggleShadow();
                      }
                    }}
                  >
                    {/* <input
                        type="checkbox"
                        className="absolute left-3 top-5"
                        id={`deviceCheckbox${idx}`}
                        // checked={selectedDevice === item.id}
                        onChange={(e) => {
                          if (!item.isActive) {
                            if (document.getElementById(e.target.id).checked) deleteDevices.push(item.id);
                            else {
                              var index = deleteDevices.indexOf(item.id);
                              if (index !== -1) {
                                deleteDevices.splice(index, 1);
                              }
                            };
                          }
                          if (deleteDevices.length > 1) {
                            selectDevice('');
                            setEditFlag(true);
                          } else {
                            selectedDevice === item.id ? selectDevice('') : selectDevice(item.id);
                            setEditFlag(false);
                          }
                        }}
                      /> */}

                    {item.deviceType === 'BLE_GW' ? (
                      <a href="#" className="w-1/3 text-blue-700 flex items-center text-left">
                        <img src="assets/img/Gateway.svg" className="h-4 mr-4" alt="" />
                        {item?.id}
                      </a>
                    ) : (
                      <div className="w-1/3 flex items-center text-left">
                        {item?.deviceType === 'BLE_TAG' ? (
                          <img src="assets/img/Bluetooth.svg" className="h-5 mr-4" alt="" />
                        ) : null}
                        {item?.deviceType === 'CATM1_TAG' ? (
                          <img src="assets/img/Cellular.svg" className="h-5 mr-4" alt="" />
                        ) : null}
                        {item?.deviceType === 'BLE_GW' ? (
                          <img src="assets/img/Gateway.svg" className="h-4 mr-4" alt="" />
                        ) : null}
                        {item?.deviceType === 'NFC_TAG' ? (
                          <img src="assets/img/NFC.svg" className="h-4 mr-4" alt="" />
                        ) : null}
                        {item?.id}
                      </div>
                    )}
                    {/* <div className="w-1/4">{item?.deviceType}</div> */}
                    <div className="w-1/4">{item?.Organization?.organizationName}</div>
                    <div className="w-1/5">
                      {item?.isActive ? (
                        <p className="text-green-700"> ACTIVE</p>
                      ) : (
                        <p className="text-red-700"> INACTIVE</p>
                      )}
                    </div>
                    <div className="w-1/5">
                      {item?.DeviceInfo !== null ? getTimeoffset(item?.DeviceInfo?.updatedAt) : `N/A`}
                    </div>
                    <div className="w-1/5 flex">
                      <img
                        src="assets/img/Edit2.svg"
                        className={`h-3 mr-4 cursor-pointer`}
                        alt=""
                        onClick={() => {
                          // if (!item.isActive) {
                          selectDevice({ id: item?.id });
                          setAction('update');
                          toggleOpenCreate();
                          // }
                        }}
                      />
                      <img
                        src="assets/img/Delete2.svg"
                        className={`h-3 ${
                          item.isActive ? 'opacity-30 cursor-not-allowed' : 'opacity-100 cursor-pointer '
                        } `}
                        alt=""
                        onClick={() => {
                          if (!item.isActive) {
                            selectDevice({ id: item?.id });
                            // selectOrg({ id: item?.id, name: item?.organizationName});
                            setOnClose(true);
                          }
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
            {!searchFlag && (
              <div className="block lg:flex mt-1 lg:mt-0 fixed bottom-4 right-14">
                <Pagination
                  className="mt-4 ml-auto shadow-2xl"
                  count={pageCount}
                  page={page}
                  onChange={handleChange}
                  variant="outlined"
                  shape="rounded"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
